/* Hallmark · component: Textarea · genre: modern-minimal · theme: maeiz-tokens */
import React from "react";
import { clsx } from "clsx";
import { fieldSurfaceClass } from "../../styles/field";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
    helperText?: string;
    fullWidth?: boolean;
    labelClassName?: string;
    textareaTextClassName?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    (
        {
            label,
            error,
            helperText,
            fullWidth = false,
            className,
            id,
            labelClassName,
            textareaTextClassName,
            rows = 4,
            disabled,
            ...props
        },
        ref,
    ) => {
        const inputId = id || `textarea-${Math.random().toString(36).slice(2, 9)}`;
        const hasError = !!error;

        return (
            <div className={clsx("flex flex-col gap-1.5", fullWidth && "w-full")}>
                {label ? (
                    <label
                        htmlFor={inputId}
                        className={clsx("text-sm font-medium text-neutral-dark dark:text-white", labelClassName)}
                    >
                        {label}
                    </label>
                ) : null}
                <textarea
                    id={inputId}
                    ref={ref}
                    rows={rows}
                    disabled={disabled}
                    className={clsx(
                        fieldSurfaceClass({ error: hasError, disabled }),
                        "min-h-[120px] resize-y px-4 py-3 leading-relaxed",
                        textareaTextClassName,
                        className,
                    )}
                    aria-invalid={hasError}
                    aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
                    {...props}
                />
                {error ? (
                    <p id={`${inputId}-error`} className="text-sm text-danger" role="alert">
                        {error}
                    </p>
                ) : null}
                {helperText && !error ? (
                    <p id={`${inputId}-helper`} className="text-sm text-neutral-secondary">
                        {helperText}
                    </p>
                ) : null}
            </div>
        );
    },
);

Textarea.displayName = "Textarea";
